<template>
    <p>
    <table class="table table-striped table-sm" v-if="calculationData.Deduction">
        <thead>
            <tr>
                <th style="width:15%">Datum</th>
                <th>Projekt</th>
                <th>Kategori</th>
                <th style="width:10%" class="text-right">Moms</th>
                <th style="width:10%" class="text-right">Kostnad</th>
                <th style="width:10%" class="text-right">Bruttokostnad</th>               
            </tr>
        </thead>   
        <tbody>
            <tr v-for="entry in calculationData.Deduction" :key="entry.id">
                <td style="width:15%">{{entry.Spent | moment("YYYY-MM-DD")}}</td>
                <td>{{entry.Project}}</td>
                <td>{{entry.Category}}</td>
                <td style="width:10%" class="text-right">{{entry.Vat | currency}}</td>
                <td style="width:10%" class="text-right">{{entry.Cost | currency}}</td>
                <td style="width:10%" class="text-right">{{entry.Deduction | currency}}</td>                 
            </tr>       
        </tbody> 
        <tfoot>
            <tr>
                <th colspan="5">Summa</th>                
                <td class="text-right"><strong>{{calculationData.Deduction.reduce((s, f) => s+f.Deduction, 0) | currency}}</strong></td>
            </tr>
        </tfoot>
    </table>
    <table class="table table-striped table-sm" v-if="calculationData.Expenses">
        <thead>
            <tr>
                <th style="width:10%">Datum</th>
                <th>Projekt</th>
                <th>Kategori</th>
                <th style="width:10%" class="text-center">Kvitto</th>
                <th style="width:10%" class="text-right">Kostnad</th>                
            </tr>
        </thead>   
        <tbody>
            <tr v-for="entry in calculationData.Expenses" :key="entry.id">
                <td style="width:10%">{{entry.Spent | formatDate}}</td>
                <td>{{entry.Project}}</td>
                <td>{{entry.Category}}</td>
                <td style="width:10%" class="text-center"><a :href="entry.Receipt"><file-text-icon/></a></td>
                <td style="width:10%" class="text-right">{{entry.Cost | currency}}</td>                 
            </tr>       
        </tbody> 
        <tfoot>
            <tr>
                <th colspan="4">Summa</th>                
                <td class="text-right"><strong>{{calculationData.Expenses.reduce((s, f) => s+f.Cost, 0) | currency}}</strong></td>
            </tr>
        </tfoot>
    </table>    
    </p>
</template>

<script>
export default {
  props: {
    calculationData: null
  } 
}
</script>

<style>

</style>
